"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Document = void 0;
const Common_1 = require("./Common");
const Base_1 = require("./Base");
const index_1 = require("../index");
class Document extends Base_1.Base {
    key = '';
    url = '';
    name = '';
    template_id = '';
    type = '';
    stage = '';
    subject = '';
    sms = '';
    data_events = [];
    data_argument = '';
    data_loader_fn = '';
    data_example = {};
    email = '';
    email_type = '';
    description = '';
    html = '';
    sitemap = null;
    metadata = {};
    allow_note = false;
    followers = [];
    roles = [];
    skipTracking = false;
    constructor(data, olMap) {
        super('documents', 12);
        (0, Common_1.setObjectProperties)(this, data, olMap, Document);
    }
}
exports.Document = Document;
index_1.olm.documents = (ref, map) => {
    return new Document(ref, map);
};
